// extracted by mini-css-extract-plugin
export default {"main":"Hearts_main__tnhRX","initialHeart":"Hearts_initialHeart__-oqeb","heart":"Hearts_heart__nU9e8","heartfall":"Hearts_heartfall__296wj"};